import { HTMLAttributes, ReactNode } from "react";
import { cn } from "src/utils/cn";

type DashboardSectionTitleProps = {
  children: ReactNode;
  className?: string;
};

export function DashboardSectionTitle({
  children,
  className,
  ...props
}: DashboardSectionTitleProps) {
  return (
    <h2 className={cn("text-3xl text-gray-800", className)} {...props}>
      {children}
    </h2>
  );
}

type DashboardSectionProps = HTMLAttributes<HTMLElement> & {
  title?: string;
  children: ReactNode;
  id?: string;
};

export function DashboardSection({
  title,
  children,
  id,
  ...props
}: DashboardSectionProps) {
  return (
    <section {...props}>
      <div
        className="flex flex-col gap-2 rounded-2xl bg-white p-4 shadow-lg sm:px-10 sm:py-6 lg:px-10 lg:py-6"
        id={id}
      >
        {title ? (
          <div className="mb-3">
            <DashboardSectionTitle>{title}</DashboardSectionTitle>
          </div>
        ) : null}

        {children}
      </div>
    </section>
  );
}
